'use client';

import { Link } from 'react-router-dom';
import styles from '../ProductDetail.module.css';

export function SungerpanHubContent() {
  return (
    <div className={styles.seoWrap}>
      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Süngerpan Nedir?</h2>
        <p className={styles.seoText}>
          Süngerpan, poliüretan sünger kırpıntılarının yüksek basınç altında özel bağlayıcılarla yeniden sıkıştırılmasıyla üretilen, yüksek
          yoğunluklu bir ses yalıtım malzemesidir. Sektörde akustik uygulama ekipleri arasında rebonded sünger, bondex sünger veya rebonded
          süngerpan olarak da bilinir. Echopan olarak süngerpanı, ses geçişini azaltmak ve darbe kaynaklı titreşimi düşürmek isteyen projeler
          için temel malzeme olarak konumlandırıyoruz.
        </p>
        <p className={styles.seoText}>
          Süngerpanın en önemli farkı, standart açık hücreli akustik süngerden daha yoğun bir yapıya sahip olmasıdır. Bu yapı sayesinde sadece
          yankı kontrolü değil, duvar, tavan ve zemin katmanlarında ses geçişini düşürmeye yardımcı olan bir yalıtım katmanı görevi görür.
          Özellikle ortak duvar, makine dairesi, jeneratör odası ve stüdyo altyapısında süngerpan olmadan kalıcı performans almak zordur.
        </p>
        <p className={styles.seoText}>
          Biz Echopan olarak sahada en sık şu soruyu alıyoruz, süngerpan tek başına yeterli mi. Bu sorunun cevabı uygulama amacına bağlıdır.
          Eğer amaç yalnızca zemin titreşimini azaltmaksa doğru kalınlıkta süngerpan çoğu projede hızlı sonuç verir. Eğer komşu daire konuşma
          sesini azaltmak hedefleniyorsa süngerpan katmanına ek olarak kaplama, sızdırmazlık ve bazı durumlarda bariyer katmanı gerekir. Bu yüzden
          ürün kadar uygulama kurgusunu da birlikte planlıyoruz.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Rebonded Süngerpan Özellikleri Nelerdir?</h2>
        <h3 className={styles.seoSubtitle}>Teknik Özellikleri</h3>
        <p className={styles.seoText}>
          Rebonded süngerpan yüksek yoğunluklu yapısıyla 100 x 100 cm plaka ölçülerinde, farklı kalınlık ve DNS seçenekleriyle üretilir.
          Echopan ürün grubunda en sık talep edilen kalınlıklar 10 mm, 20 mm, 30 mm, 40 mm ve 50 mm seçenekleridir. Kalınlık arttıkça darbe
          sönümleme artar, yoğunluk arttıkça malzemenin ezilmeye karşı dayanımı yükselir. Bu yüzden teknik seçim sadece kalınlığa değil, yük
          tipine ve uygulama alanına göre yapılmalıdır.
        </p>
        <p className={styles.seoText}>
          Rebonded sünger üretim tekniği nedeniyle homojen bir gövde yapısı sunar. Yüzeyde büyük boşluklar bulunmadığı için malzeme genelinde
          tutarlı performans elde edilir. Şap altında, duvar karkasında ya da makine altında çalışırken farklı noktalarda ani performans kaybı
          riski düşer. Bu da uzun vadede bakım ihtiyacını azaltır.
        </p>
        <p className={styles.seoText}>
          Teknik seçim sırasında sadece katalog bilgisine bakmak yerine kullanım senaryosunu netleştirmek gerekir. Örneğin hafif ofis bölmesinde
          orta yoğunluklu bir süngerpan iyi sonuç verirken, ağır ekipman taşıyan zeminlerde aynı ürün kısa sürede sıkışabilir. Echopan tarafında
          teklif hazırlarken ses kaynağını, taşıyıcı sistemi, kaplama tipini ve kullanım yoğunluğunu birlikte değerlendiriyoruz. Böylece hem ürün
          performansı hem uygulama ömrü dengelenmiş olur.
        </p>

        <h3 className={styles.seoSubtitle}>Ses Yutuculuk Performansı</h3>
        <p className={styles.seoText}>
          Süngerpan, sesi tamamen yok eden bir malzeme değil, ses enerjisini sönümleyerek geçişi azaltan bir katmandır. Hava doğuşumlu seslerde
          tek başına uygulama sınırlı etki gösterebilir ancak duvar sistemi içinde alçıpan ve doğru montajla birlikte ciddi fark yaratır. Darbe
          sesi ve titreşim kaynaklı gürültüde ise rebonded sünger doğası gereği daha güçlü performans verir.
        </p>
        <p className={styles.seoText}>
          Yüksek frekanslı yankı sorunlarında tek başına süngerpan yerine akustik yüzey ürünleri eklemek gerekir. Bu tip projelerde alt katmanda
          süngerpan, üst katmanda <Link to="/akustik-sunger" rel="follow">akustik sünger</Link> kullanımı hem ses geçişini hem oda içi yansımayı
          birlikte kontrol eder.
        </p>
        <p className={styles.seoText}>
          Ses yutuculuk performansını doğru okumak için malzemenin tek başına değil, sistem içinde çalıştığını unutmamak gerekir. Duvar kesitinde
          süngerpanın yanında kullanılan profil tipi, kaplama kalınlığı, boşluk oranı ve ek yeri uygulaması sonucu doğrudan etkiler. Sahada küçük
          görünen bir boşluk bile ses sızıntısını artırabilir. Bu nedenle montaj kalitesi, ürün seçimi kadar kritik bir başlıktır.
        </p>

        <h3 className={styles.seoSubtitle}>Renk ve Ölçü Seçenekleri</h3>
        <p className={styles.seoText}>
          Rebonded süngerpan çoğunlukla çok renkli kırpıntı görünümlü doğal yapısıyla sunulur. Bu görünüm malzemenin geri dönüştürülmüş lifli
          yapısından gelir ve kalite göstergesi olarak kabul edilir. Standart plaka ölçüsü dışında proje bazlı kesim yapılabilir. Tesisat geçişi,
          kolon dönüşü veya özel duvar modülleri için uygulama öncesi kesim listesi çıkarıldığında sahadaki montaj süresi önemli ölçüde kısalır.
        </p>
        <p className={styles.seoText}>
          Renk konusu teknik performansı doğrudan değiştirmez, ancak bazı projelerde görünür kullanım olduğunda estetik beklenti önem kazanır.
          Bu tip taleplerde kaplama katmanları veya dekoratif panellerle kombinasyon öneriyoruz. Ölçü tarafında ise standart dışı kesimler için
          proje çizimi paylaşılması süreci hızlandırır. Doğru kesim listesiyle hem fire düşer hem uygulama sırasında zaman kaybı önlenir.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Süngerpan Ne İşe Yarar?</h2>
        <h3 className={styles.seoSubtitle}>Yankı ve Eko Kontrolü</h3>
        <p className={styles.seoText}>
          Süngerpanın ana görevi doğrudan yankı paneli olmak değil, yapısal ses geçişini düşürmektir. Ancak duvar sistemine doğru yerleştirildiğinde
          oda içinde yankıyı artıran sert yüzey etkisini de dolaylı olarak azaltır. Tam yankı kontrolü istenen hacimlerde üzerine <Link to="/akustik-piramit-sunger" rel="follow">piramit akustik sünger</Link> ya da
          <Link to="/akustik-yumurta-sunger" rel="follow"> yumurta akustik sünger</Link> eklemek gerekir.
        </p>

        <h3 className={styles.seoSubtitle}>Ortam Akustiğine Katkıları</h3>
        <p className={styles.seoText}>
          Ortam akustiği sadece duyulan ses seviyesinden ibaret değildir. Sesin anlaşılır olması, konuşma netliği, müzikte frekans dengesi ve
          çalışma konforu birlikte değerlendirilir. Süngerpan altyapısı, komşu hacimlerden gelen ses yükünü azaltarak odadaki akustik düzenlemenin
          daha verimli çalışmasını sağlar. Yani doğru akustik çözümde süngerpan temel katman, akustik kaplama ise final katmanı olarak görev alır.
        </p>
        <p className={styles.seoText}>
          Özellikle toplantı odası ve yayın alanlarında kullanıcı deneyimi ses kalitesiyle doğrudan ilişkilidir. Net duyulmayan konuşma, tekrar
          ihtiyacını artırır ve iletişimi yavaşlatır. Süngerpan altyapısı doğru kurulduğunda dış etkiler azalır, içeride yapılan akustik düzenleme
          daha stabil çalışır. Bu da mekanın kullanım kalitesini artırır ve işletme tarafında verimliliğe katkı sağlar.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Rebonded Sünger Nerelerde Kullanılır?</h2>
        <h3 className={styles.seoSubtitle}>Ofis ve Toplantı Odaları</h3>
        <p className={styles.seoText}>
          Açık ofis ve toplantı odalarında ses mahremiyeti kritik bir ihtiyaçtır. Rebonded sünger bölme duvar içinde kullanıldığında odalar arası
          konuşma geçişi azalır. Cam bölmeli ofislerde tek başına yeterli olmayabilir, bu durumda duvar tavan kapı üçlüsü birlikte ele alınır.
          Ofis projelerinde en çok tercih edilen kalınlıklar <Link to="/bondex-sunger-20mm" rel="follow">Bondex Sünger 20mm</Link> ve <Link to="/bondex-sunger-30mm" rel="follow">Bondex Sünger 30mm</Link> seviyesidir.
        </p>
        <p className={styles.seoText}>
          Kurumsal projelerde hızlı uygulama ve temiz montaj da önemli bir kriterdir. Çalışanların bulunduğu ofislerde uzun süreli inşaat süreci
          operasyonu zorlaştırır. Bu nedenle önceden planlanan modüler kesim ve etaplı uygulama yöntemiyle ilerliyoruz. Süngerpanın doğru planlanmış
          montajı, işi durdurmadan ses konforunu iyileştirmeye imkan verir.
        </p>

        <h3 className={styles.seoSubtitle}>Müzik Stüdyoları</h3>
        <p className={styles.seoText}>
          Stüdyo projelerinde ilk hedef, içeride üretilen yüksek sesin komşu hacimlere taşınmasını azaltmaktır. Rebonded sünger duvar ve tavan
          karkasında temel yalıtım katmanını oluşturur. İç akustik için ise üzerine akustik panel uygulaması yapılır. Yüksek performans hedeflenen
          stüdyolarda <Link to="/bariyerli-bondex-sunger" rel="follow">bariyerli bondex sünger</Link> ile kombine sistem kurulması önerilir.
        </p>
        <p className={styles.seoText}>
          Ev stüdyosu projelerinde en sık hata, sadece görünen duvarları kaplayıp kapı ve havalandırma detaylarını atlamaktır. Oysa ses kaçağı
          çoğunlukla bu noktalarda oluşur. Süngerpan uygulamasını kapı kasası, priz geçişi ve köşe birleşimleriyle birlikte ele aldığımızda çok
          daha dengeli sonuç alıyoruz. Kısacası stüdyo yalıtımı malzeme değil sistem işidir.
        </p>

        <h3 className={styles.seoSubtitle}>Konferans ve Seminer Salonları</h3>
        <p className={styles.seoText}>
          Konferans salonlarında hem konuşma anlaşılırlığı hem dış gürültüden korunma önemlidir. Rebonded sünger, salonu çevreleyen yapı elemanlarında
          ses geçişini azaltır. Sonrasında tavan ve yan duvarlarda akustik yüzey kaplamalarıyla reverberasyon süresi kontrol altına alınır. Bu iki
          adım birlikte uygulanmadığında salon içinde ya ses dağılır ya da dışarıya ses kaçağı devam eder.
        </p>
        <p className={styles.seoText}>
          Büyük hacimli salonlarda frekans dağılımı homojen olmazsa arka sıralarda konuşma anlaşılırlığı düşer. Bu yüzden altyapı yalıtım katmanı
          olarak rebonded sünger, üst katmanda ise akustik panel dağılımı birlikte hesaplanmalıdır. Uygulama sonrası salonda konuşma testi ve
          gerekirse lokal takviye yaparak son ayarları tamamlıyoruz.
        </p>

        <h3 className={styles.seoSubtitle}>Çağrı Merkezleri</h3>
        <p className={styles.seoText}>
          Çağrı merkezlerinde yoğun konuşma trafiği nedeniyle gürültü seviyesi hızla yükselir. Rebonded sünger bölme ve tavan altyapısında kullanılarak
          ses taşması düşürülür, ardından akustik emici panellerle operatör konforu artırılır. Bu yaklaşım hem müşteri görüşme kalitesini hem çalışan
          odaklanmasını iyileştirir.
        </p>
        <p className={styles.seoText}>
          Çağrı merkezi projelerinde hedef yalnızca daha sessiz bir ortam değildir, aynı zamanda anlaşılır bir iletişim kalitesidir. Süngerpan
          uygulamasıyla altyapı gürültüsünü düşürdüğümüzde operatörler daha düşük sesle konuşabilir. Bu etki uzun vardiyalarda yorgunluğu azaltır
          ve kalite skorlarına olumlu yansır.
        </p>

        <h3 className={styles.seoSubtitle}>Ev Sinema Odaları</h3>
        <p className={styles.seoText}>
          Ev sinema odalarında düşük frekanslı bas sesler komşulara en çok rahatsızlık veren unsurdur. Rebonded sünger bu sesleri tamamen yok etmez
          ancak yapı geçişini düşürerek ses yükünü azaltır. Yüksek izolasyon isteyen kullanıcılar için <Link to="/cift-bariyerli-bondex-sunger" rel="follow">çift bariyerli bondex</Link> seçenekleri de
          değerlendirilmelidir.
        </p>
        <p className={styles.seoText}>
          Sinema odası projelerinde hoparlör gücü arttıkça altyapı gereksinimi de artar. Sadece dekoratif panel uygulamasıyla güçlü bas frekansları
          kontrol etmek mümkün olmaz. Rebonded sünger katmanı erken aşamada planlandığında hem komşu şikayeti riski düşer hem odanın kendi akustik
          düzenlemesi daha kararlı hale gelir.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Süngerpan ile Ses Yalıtımı Sağlanır mı?</h2>
        <h3 className={styles.seoSubtitle}>Süngerpan Ses Yalıtımı ile Akustik Düzenleme Arasındaki Fark</h3>
        <p className={styles.seoText}>
          Ses yalıtımı, bir ortamdan diğerine ses geçişini azaltmak için yapılır. Akustik düzenleme ise aynı odanın içindeki yankı ve yansımayı
          kontrol etmeyi hedefler. Süngerpan ses yalıtımı katmanında çalışır. Akustik düzenleme içinse genelde farklı yüzey ürünleri gerekir.
          İkisini karıştırmadan doğru sırayla uyguladığımızda hem dış ses geçişi azalır hem oda içinde net ve dengeli bir işitme elde edilir.
        </p>
        <p className={styles.seoText}>
          Pratikte bu farkı şöyle özetliyoruz, yalıtım komşu odayı korur, akustik düzenleme ise bulunduğunuz odanın dinleme kalitesini iyileştirir.
          Süngerpan bu iki başlıktan birincisinde kritik rol oynar. İkinci başlıkta ise yüzey kaplamaları devreye girer. Doğru beklentiyle ürün
          seçildiğinde kullanıcı memnuniyeti belirgin şekilde artar.
        </p>

        <h3 className={styles.seoSubtitle}>Hangi Ses Problemlerini Azaltır?</h3>
        <p className={styles.seoText}>
          Süngerpan en çok darbe ve titreşim tabanlı seslerde katkı verir. Üst kattan gelen ayak sesi, makine titreşimi, kapı çarpma etkisi gibi
          yapısal iletimli problemlerde performansı belirgindir. Konuşma ve televizyon sesi gibi hava yolu seslerinde de sistemin parçası olarak
          etkilidir. Fakat bu tip sorunlarda tek katman uygulama yerine bariyer, alçıpan, bant ve detay sızdırmazlığıyla birlikte planlama gerekir.
        </p>
        <p className={styles.seoText}>
          Hangi ses probleminin baskın olduğunu tespit etmek bu aşamada çok önemlidir. Bazı projelerde kullanıcı konuşma sesinden şikayet ettiğini
          belirtir ama asıl problem titreşim köprüsüdür. Bu nedenle yerinde keşif ya da detaylı proje bilgisiyle ilerlemek doğru ürün seçimini
          kolaylaştırır ve gereksiz maliyeti önler.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Rebonded Sünger ile Akustik Sünger Arasındaki Farklar</h2>
        <h3 className={styles.seoSubtitle}>Hangi Ürün Hangi Mekân İçin Daha Uygundur?</h3>
        <p className={styles.seoText}>
          Rebonded sünger yüksek yoğunluklu bir yalıtım katmanıdır. Akustik sünger ise düşük yoğunluklu bir yüzey emicisidir. Ortak duvar ses
          problemi olan bir evde önce rebonded sünger planlanır. Stüdyoda kayıt netliği içinse akustik sünger yüzey kaplaması devreye girer.
          En verimli yaklaşım bu iki malzemeyi rakip gibi değil, görevleri farklı iki tamamlayıcı çözüm olarak kullanmaktır.
        </p>
        <p className={styles.seoText}>
          Hacim küçüldükçe yanlış ürün seçiminin etkisi büyür. Küçük bir podcast odasında sadece akustik sünger kullanmak dış ses geçişi sorununu
          çözmez. Aynı şekilde sadece rebonded sünger kullanmak da oda içi yankıyı beklenen seviyede düşürmez. Echopan olarak her projede önce
          problem tipini ayırıyoruz, sonra katman sırasını netleştiriyoruz.
        </p>
        <p className={styles.seoText}>
          Bu yaklaşım müşteriye net bir yol haritası sunar. Önce ses geçişini düşürürüz, ardından odanın iç akustiğini dengeleriz. Böylece hem
          teknik performans hem bütçe yönetimi daha kontrollü olur. Tek bir malzemeden mucize beklemek yerine doğru katman kombinasyonunu kurmak,
          kalıcı sonucun anahtarıdır.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Süngerpan Nasıl Uygulanır?</h2>
        <h3 className={styles.seoSubtitle}>Montaj Öncesi Hazırlık</h3>
        <p className={styles.seoText}>
          Uygulama öncesinde yüzeyin kuru, temiz ve düz olması gerekir. Gevşek sıva, tozlu beton ve nemli alanlar yapışma performansını düşürür.
          Montajdan önce metraj ve kesim planı hazırlanmalı, priz ve tesisat geçişleri işaretlenmelidir. Bu hazırlık yapılmadan sahaya girildiğinde
          malzeme kaybı artar ve ek yeri boşlukları nedeniyle performans düşer.
        </p>

        <h3 className={styles.seoSubtitle}>Yapıştırma ve Montaj Aşamaları</h3>
        <p className={styles.seoText}>
          Süngerpan uygulaması doğrudan yapıştırma veya karkas içine yerleştirme şeklinde yapılabilir. Yapıştırmalı yöntemde uygun yapıştırıcı
          homojen sürülür, plaka yüzeye bastırılır ve ek yerleri sıkı kapatılır. Karkas yöntemde ise levhalar boşluk bırakmadan kesilir ve üzerine
          kaplama katmanı gelir. Uygulama sonrası en kritik adım sızdırmazlık kontrolüdür. Küçük boşluklar bile ses köprüsü oluşturabilir.
        </p>
        <p className={styles.seoText}>
          Montaj sırasında sıra ve disiplin önemlidir. Önce altyapı kontrol edilir, sonra levha yerleşimi tamamlanır, en son kaplama katmanına
          geçilir. Arada bırakılan boşluklar uygulama sonunda fark edilse bile düzeltmesi maliyetli olur. Bu nedenle biz her aşamada kontrol listesi
          kullanıyor ve teslim öncesi son denetim yapıyoruz.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Süngerpan Seçerken Nelere Dikkat Edilmelidir?</h2>
        <h3 className={styles.seoSubtitle}>Kalınlık Seçimi</h3>
        <p className={styles.seoText}>
          Kalınlık seçimi projedeki hedefe göre yapılmalıdır. İnce renovasyonlarda 10 mm veya 20 mm seçenekler alan kazandırır. Daha güçlü darbe
          sönümleme gereken yerlerde 30 mm üstü kalınlıklar tercih edilir. Endüstriyel titreşim kaynaklarında <Link to="/bondex-sunger-40mm" rel="follow">Bondex Sünger 40mm</Link> ve <Link to="/bondex-sunger-50mm" rel="follow">Bondex Sünger 50mm</Link>
          daha güvenli bir aralık sunar.
        </p>

        <h3 className={styles.seoSubtitle}>Kullanım Alanına Göre Ürün Tercihi</h3>
        <p className={styles.seoText}>
          Darbe ve titreşim odaklı projelerde standart süngerpan çoğu zaman yeterlidir. Hava yolu sesinde daha yüksek beklenti varsa bariyerli
          ürünler tercih edilmelidir. Özellikle ince duvar kesitinde yüksek performans bekleniyorsa <Link to="/bariyerli-bondex-sunger-33mm" rel="follow">Bariyerli Bondex Sünger 33mm</Link> iyi bir
          denge sunar. Alan müsaitse çift bariyerli modellerle daha güçlü sonuç alınabilir.
        </p>
        <p className={styles.seoText}>
          Seçim aşamasında sık yapılan hata, en kalın ürünü otomatik olarak en doğru çözüm sanmaktır. Oysa bazı mekanlarda kalınlık arttıkça alan
          kaybı büyür ve montaj detayı zorlaşır. Doğru seçim, hedef performans ile mekan sınırlarını dengede tutan seçimdir. Echopan teknik ekibi
          bu dengeyi proje bazında netleştirerek öneri sunar.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Süngerpan m² Fiyatları 2026</h2>
        <h3 className={styles.seoSubtitle}>Fiyatı Etkileyen Faktörler</h3>
        <p className={styles.seoText}>
          Süngerpan fiyatı kalınlık, yoğunluk, metraj, kesim tipi ve teslimat lokasyonuna göre değişir. Aynı kalınlıkta bile farklı DNS değerleri
          maliyeti etkiler. Buna ek olarak bariyerli katman talebi fiyatı yukarı çeker ancak hava yolu ses performansını da artırır. Echopan
          olarak teklif verirken yalnızca m² birim fiyatı değil, toplam sistem maliyetini dikkate alıyoruz.
        </p>
        <p className={styles.seoText}>
          Referans için standart bondex sünger başlangıç fiyatı ürün grubunda m² bazında <Link to="/bondex-sunger" rel="follow">bondex sünger fiyatı</Link> üzerinden görülebilir.
          Projede ses hedefi yükseldikçe bariyerli ve çift bariyerli çözümlerle maliyet güncellenir. Doğru ürün seçildiğinde tekrar uygulama
          ihtiyacı azaldığı için toplam bütçe daha kontrollü kalır.
        </p>

        <h3 className={styles.seoSubtitle}>Metrekare Hesabı Nasıl Yapılır?</h3>
        <p className={styles.seoText}>
          Metrekare hesabı için uygulanacak her yüzeyin en ve boy ölçüsü çarpılır, ardından toplamlar toplanır. Kapı ve pencere boşlukları projeye
          göre düşülebilir ancak detay dönüşleri ayrıca hesaplanmalıdır. Sahada fire payı bırakmadan sipariş vermek risklidir. Biz genelde temiz
          metraja ek olarak yüzde 5 ile yüzde 10 aralığında güvenlik payı öneriyoruz.
        </p>
        <p className={styles.seoText}>
          Özellikle çok köşeli mekanlarda yalnızca net duvar alanını toplamak eksik siparişe yol açabilir. Kolon dönüşleri, niş bölgeler ve tavan
          kırımları da hesap dahiline alınmalıdır. Uygulama planı çizim üzerinden yapıldığında hem maliyet daha doğru çıkar hem montaj günü sürpriz
          yaşanmaz.
        </p>
      </section>

      <section className={styles.seoCard}>
        <h2 className={styles.seoH2}>Süngerpan Hakkında Sık Sorulan Sorular</h2>
        <h3 className={styles.seoSubtitle}>Süngerpan Isı Yalıtımı Sağlar mı?</h3>
        <p className={styles.seoText}>
          Süngerpanın ana kullanım amacı ses yalıtımı ve titreşim sönümlemedir. Isı tarafında yardımcı katkı sağlayabilir ancak tek başına güçlü
          bir ısı yalıtım malzemesi olarak değerlendirilmez. Isı odaklı projelerde ek ısı yalıtım katmanlarıyla birlikte planlama yapılmalıdır.
        </p>

        <h3 className={styles.seoSubtitle}>Rebonded Sünger Yangına Dayanıklı mıdır?</h3>
        <p className={styles.seoText}>
          Ürün sınıfı üretim tipine göre değişir ve proje onaylarında ilgili sertifikaların kontrol edilmesi gerekir. Echopan tedarik sürecinde
          talebe göre uygun ürün sınıfı ve teknik dokümantasyon paylaşır. Uygulama yapılacak bina yönetmeliğine uygun sınıf seçimi performanstan
          önce güvenlik açısından zorunludur.
        </p>

        <h3 className={styles.seoSubtitle}>Süngerpanın Ömrü Ne Kadardır?</h3>
        <p className={styles.seoText}>
          Doğru yoğunluk seçimi ve doğru montajla süngerpan uzun yıllar performansını korur. Ağır yük altında yanlış DNS seçimi yapılırsa zamanla
          sıkışma görülebilir. Bu nedenle ürün ömrünü belirleyen tek unsur malzeme değil, doğru projeleme ve doğru uygulamadır.
        </p>

        <h3 className={styles.seoSubtitle}>Süngerpan Temizliği Nasıl Yapılır?</h3>
        <p className={styles.seoText}>
          Süngerpan genelde kaplama altında kaldığı için rutin temizlik gerektirmez. Açıkta kullanılan uygulamalarda kuru temizlik ve düşük basınçlı
          vakum tercih edilir. Yoğun sıvı teması önerilmez. Kimyasal temizleyici kullanmadan önce küçük bir alanda deneme yapmak daha güvenlidir.
        </p>
        <p className={styles.seoText}>
          Uzun ömür için en iyi yöntem doğru ürünün doğru yerde kullanılmasıdır. Gereğinden düşük yoğunluk seçimi, yanlış yapıştırıcı veya eksik
          detay çözümü ürün ömrünü kısaltır. Echopan olarak süngerpan projelerinde satış sonrası teknik yönlendirme de veriyor, uygulama sonrası
          performansın korunması için pratik bakım önerileri paylaşıyoruz.
        </p>
        <p className={styles.seoText}>
          Süngerpan yatırımı yapan kullanıcılar için en değerli kazanım, zamanla artan konfor farkıdır. Doğru uygulanmış bir sistemde ses kaçağı
          azaldıkça yaşam ve çalışma kalitesi yükselir. Bizim yaklaşımımız yalnızca ürün satmak değil, projenin gerçek ihtiyacına uygun sürdürülebilir
          bir çözüm teslim etmektir. Bu nedenle her projede önce ihtiyacı netleştiriyor, ardından en uygun rebonded süngerpan katmanını belirliyoruz.
        </p>
      </section>
    </div>
  );
}
